module.exports = __webpack_public_path__ + "static/tan_kayalithica-7191b622eef879b2a9e4ddf19ac77418.jpg";